import { RED, BLUE, RACK, ENTERING_SPACE, MOVE_SETS } from '../constants';

function makePiece(id, moves, color) {
  if (color === BLUE) {
    moves = moves.map((tileValue) =>
      tileValue === ENTERING_SPACE || tileValue === RACK
        ? tileValue
        : 11 - tileValue
    );
  }
  return {
    id,
    color,
    currentPos: RACK,
    moveSet: moves,
  };
}

export function setupPieces() {
  let allPieces = [];
  for (let [index, moveSet] of MOVE_SETS.entries()) {
    allPieces.push(makePiece('r' + index, moveSet, RED));
    allPieces.push(makePiece('b' + index, moveSet, BLUE));
  }
  return allPieces;
}
